import React, {FC} from 'react'
import {PageTitle} from '../../../_template/layout/core'
// import {RelayPointsPage} from './RelayPointsPage'
import {useIntl} from 'react-intl'
import {UsersListWrapper} from './relayPoints-list/RelayPointsList'

const RelayPointsPageWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.RELAY.POINTS'})}</PageTitle>
      <UsersListWrapper />
    </>
  )
}

export default RelayPointsPageWrapper
